/**
 * Syncs theme quantity input with Bundler quantity break tiers on PDP.
 * Bundler updates prices when its radio buttons are clicked, but not when
 * the native quantity selector changes. This script bridges that gap.
 */
(function () {
  const BUNDLE_SELECTOR = '.bundler-volume-target-element.bndlr-quantity-break';
  let isSyncing = false;

  function getTiers(bundleWidget) {
    const tiers = [];

    bundleWidget.querySelectorAll('.bndlr-radio-container').forEach((container) => {
      const input = container.querySelector('input[type="radio"]');
      if (!input) return;

      const discountedEl = container.querySelector('.bndlr-discounted-price');
      const originalEl = container.querySelector('.bndlr-original-price');

      tiers.push({
        minQty: parseInt(input.value, 10),
        discountedHtml: discountedEl?.innerHTML?.trim(),
        originalHtml: originalEl?.innerHTML?.trim(),
        discountedPrice: discountedEl?.dataset.currentprice,
        originalPrice: originalEl?.dataset.currentprice,
        container,
        input,
      });
    });

    return tiers.sort((a, b) => a.minQty - b.minQty);
  }

  function getTierForQuantity(tiers, quantity) {
    if (!tiers.length) return null;

    let matchedTier = tiers[0];

    for (const tier of tiers) {
      if (quantity >= tier.minQty) matchedTier = tier;
      else break;
    }

    return matchedTier;
  }

  function updateBundlerActiveState(bundleWidget, tier) {
    bundleWidget.querySelectorAll('.bndlr-radio-container').forEach((container) => {
      const isActive = container === tier.container;
      container.dataset.bundlerBreakActive = isActive ? 'true' : 'false';
      const input = container.querySelector('input[type="radio"]');
      if (input) input.checked = isActive;
    });
  }

  function updateMainPrice(sectionId, tier) {
    const priceBlock = document.querySelector(`#price-${sectionId} .price`);
    if (!priceBlock || !tier.discountedHtml) return;

    const hasDiscount =
      tier.originalPrice &&
      tier.discountedPrice &&
      tier.originalPrice !== tier.discountedPrice;

    const saleCompare = priceBlock.querySelector('.price__sale s.price-item--regular');
    const salePrice = priceBlock.querySelector('.price__sale .price-item--sale');
    const regularPrice = priceBlock.querySelector('.price__regular .price-item--regular');

    if (hasDiscount) {
      priceBlock.classList.add('price--on-sale');
      if (saleCompare && tier.originalHtml) saleCompare.innerHTML = tier.originalHtml;
      if (salePrice) salePrice.innerHTML = tier.discountedHtml;
    } else {
      priceBlock.classList.remove('price--on-sale');
      if (regularPrice) regularPrice.innerHTML = tier.discountedHtml;
    }
  }

  function updatePricePerItem(sectionId, tier) {
    const pricePerItemEl = document.querySelector(
      `#Price-Per-Item-${sectionId} .price-per-item--current`
    );
    if (!pricePerItemEl || !tier.discountedHtml) return;

    const volumeTemplate = document.querySelector(`#Volume-${sectionId} [data-text]`);
    const template = volumeTemplate?.dataset?.text;

    if (template) {
      const priceText = tier.discountedHtml.replace(/&nbsp;/g, ' ').trim();
      const moneyMatch = template.match(/(?:[\d]+[.,][\d]+|\d+)\s*(?:€|EUR)|€\s*(?:[\d]+[.,][\d]+|\d+)/);

      if (moneyMatch) {
        pricePerItemEl.innerHTML = template.replace(moneyMatch[0], priceText);
        return;
      }
    }

    pricePerItemEl.innerHTML = tier.discountedHtml;
  }

  function syncQuantityToBundler(quantityInput) {
    if (isSyncing) return;

    const productInfo = quantityInput.closest('product-info');
    if (!productInfo) return;

    const bundleWidget = productInfo.querySelector(BUNDLE_SELECTOR);
    if (!bundleWidget) return;

    const quantity = parseInt(quantityInput.value, 10);
    if (Number.isNaN(quantity)) return;

    const tiers = getTiers(bundleWidget);
    const tier = getTierForQuantity(tiers, quantity);
    if (!tier) return;

    const sectionId = productInfo.dataset.section;
    if (!sectionId) return;

    isSyncing = true;
    updateBundlerActiveState(bundleWidget, tier);
    updateMainPrice(sectionId, tier);
    updatePricePerItem(sectionId, tier);
    isSyncing = false;
  }

  function onQuantityChange(event) {
    if (!event.target.matches('.quantity__input')) return;
    syncQuantityToBundler(event.target);
  }

  function initExistingWidgets() {
    document.querySelectorAll(BUNDLE_SELECTOR).forEach((widget) => {
      const productInfo = widget.closest('product-info');
      const quantityInput = productInfo?.querySelector('.quantity__input');
      if (quantityInput) syncQuantityToBundler(quantityInput);
    });
  }

  function observeBundlerWidgets() {
    let initTimer;

    const observer = new MutationObserver(() => {
      clearTimeout(initTimer);
      initTimer = setTimeout(initExistingWidgets, 100);
    });

    observer.observe(document.body, { childList: true, subtree: true });
  }

  document.addEventListener('change', onQuantityChange);
  document.addEventListener('input', onQuantityChange);

  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.variantChange, () => {
      requestAnimationFrame(initExistingWidgets);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      observeBundlerWidgets();
      initExistingWidgets();
    });
  } else {
    observeBundlerWidgets();
    initExistingWidgets();
  }
})();
